// Makes the product-page media gallery slider loop endlessly instead of
// disabling the prev/next arrows at the first/last image.
//
// Scoped to <slider-component id="GalleryViewer-*"> instances rendered by
// snippets/product-media-gallery.liquid. Does not touch other sliders
// (search drawer, mega-menu, etc).
//
// t-product.js defines <slider-component> with `enableSliderLooping = false`
// hardcoded, which disables the arrows at the ends. We can't safely edit
// t-product.js directly (large core file), so this file re-enables looping
// and rebinds the arrow buttons after the component has initialized.
//
// Wrap-around jumps (last -> first, first -> last) use an INSTANT scroll
// rather than the gallery's normal smooth scroll. The gallery track has
// scroll-behavior: smooth, so an animated jump from the last slide back to
// scrollLeft 0 plays backwards (looks like "previous" even after clicking
// "next"). A true seamless continuous-scroll loop would need cloned slide
// nodes appended/prepended to the track, which risks breaking the media IDs
// the zoom modal, thumbnails, and video/model-viewer elements rely on - so
// we keep it to a clean instant cut at the loop boundary instead.

(function () {
    function setupGalleryLoop(gallery) {
        if (gallery.dataset.loopBound === 'true') return;

        var prevBtn = gallery.querySelector('button[name="previous"]');
        var nextBtn = gallery.querySelector('button[name="next"]');
        if (!gallery.slider || !prevBtn || !nextBtn) return;

        gallery.dataset.loopBound = 'true';

        // Stop SliderComponent.update() from disabling the arrows at the ends
        gallery.enableSliderLooping = true;

        // Clone the buttons to drop the original (non-looping) click listener
        // that t-product.js's SliderComponent attached in its constructor.
        var newPrevBtn = prevBtn.cloneNode(true);
        var newNextBtn = nextBtn.cloneNode(true);
        prevBtn.replaceWith(newPrevBtn);
        nextBtn.replaceWith(newNextBtn);

        function goTo(direction) {
            var slider = gallery.slider;
            if (!slider) return;

            var total = (gallery.sliderItemsToShow && gallery.sliderItemsToShow.length) || gallery.sliderItems.length;
            var current = gallery.currentPage || 1;
            var isFirst = current <= 1;
            var isLast = current >= total;

            if (direction === 'previous' && isFirst) {
                // Wrap to last slide - instant, so it doesn't animate backwards
                slider.scrollTo({ left: slider.scrollWidth - slider.clientWidth, behavior: 'instant' });
                return;
            }

            if (direction === 'next' && isLast) {
                // Wrap to first slide - instant, so it doesn't animate backwards
                slider.scrollTo({ left: 0, behavior: 'instant' });
                return;
            }

            var offset = gallery.sliderItemOffset || slider.clientWidth;
            var position = direction === 'next' ? slider.scrollLeft + offset : slider.scrollLeft - offset;
            slider.scrollTo({ left: position });
        }

        newPrevBtn.addEventListener('click', function (event) {
            event.preventDefault();
            goTo('previous');
        });
        newNextBtn.addEventListener('click', function (event) {
            event.preventDefault();
            goTo('next');
        });
    }

    function initGalleryLoops() {
        document.querySelectorAll('slider-component[id^="GalleryViewer-"]').forEach(setupGalleryLoop);
    }

    document.addEventListener('DOMContentLoaded', initGalleryLoops);
    // Rebind after variant/product swaps that replace the product-info node
    document.addEventListener('product-info:loaded', initGalleryLoops);
})();
